export default {
  range(time1, time2) {
    if (!time1 || !time2) return '';
    const out1 = this.time(time1);
    const out2 = this.time(time2);
    return `${out1} - ${out2}`;
  },
  time(time_full) {
    if (!time_full) return '';
    const arr = time_full.split(':');
    return `${arr[0]}:${arr[1]}`;
  }
};
